import React, { Fragment, useEffect, useState } from 'react';
import {
    Row, Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Label, Form, Button, Card, CardBody, Badge, Table
} from "reactstrap";
import TicketModal from './ticket-modal';
import EditPolicyProductChangeModal from '../../sales/policies/view-policy-details/modal-components/edit-policy-product-change-modal';
import ViewPolicyModal from '../../sales/policies/view-policy-details/view-policy-modal';

const PolicyEditRequestModalStep = (props) => {

    const [changeValues, setChangeValues] = useState([]);
    const [oldDetails, setOldDetails] = useState({});
    const [newDetails, setNewDetails] = useState({});
    const [valuesForModel, setValuesForModel] = useState([]);
    const [valuesForVariant, setValuesForVariant] = useState([]);
    const [valuesForFuel, setValuesForFuel] = useState([]);
    const [valuesForTransmission, setValuesForTransmission] = useState([]);
    const [policyData, setPolicyData] = useState([]);
    const [documentUrl, setDocumentUrl] = useState("");
    const [viewDealershiEditModal, setEditRequestModal] = useState(false);
    const toggleViewEditModal = () => setEditRequestModal(!viewDealershiEditModal);
    const [salesPolicyId, setSalesPolicyId] = useState("");
    const { rowData } = props
    const ticketDetails = props.rowData;

    useEffect(() => {
        if (rowData?.payload) {
            const payloadData = JSON.parse(rowData.payload);
            const sales_policy_id = payloadData?.updatedData?.document_id;
            const documenturl = payloadData?.updatedData?.document;
            // console.log(sales_policy_id,"sales_policy_id")
            setDocumentUrl(documenturl);
            setSalesPolicyId(sales_policy_id);


            const oldData = payloadData?.reject;
            console.log(oldData, 'oldData')
            const newData = payloadData?.accept;
            const policyExtraData = payloadData?.policyExtraData;
            setOldDetails(oldData || {});
            // if (oldData && payloadData?.change_values) {
            //     let proposerDetailsOld = oldData?.[1]?.Body
            //     let travellerDetailsOld = oldData?.[2]?.Body
            //     let nomineesDetailsOld = oldData?.[3]?.Body

            //     let proposerDetailsUpdate = payloadData?.change_values?.proposers[0]
            //     let travellerDetailsUpdate = payloadData?.change_values?.travellers[0]
            //     let nomineeDetailsUpdate = payloadData?.change_values?.nominees[0]

            //     let changesValues = []
            //     if (proposerDetailsOld && proposerDetailsUpdate) {
            //         const changedFields = Object.keys(proposerDetailsOld).reduce((acc, key) => {
            //             if (
            //                 proposerDetailsUpdate.hasOwnProperty(key) &&
            //                 String(proposerDetailsOld[key]) !== String(proposerDetailsUpdate[key])
            //             ) {
            //                 acc.push({
            //                     details: key,
            //                     old: proposerDetailsOld[key],
            //                     new: proposerDetailsUpdate[key]
            //                 });
            //             }
            //             return acc;
            //         }, []);
            //         changesValues = changesValues.concat(changedFields); // <-- fix here
            //         // setProposerChangedFields(changedFields);
            //     }
            //     if (travellerDetailsOld && travellerDetailsUpdate) {
            //         const changedFields = Object.keys(travellerDetailsOld).reduce((acc, key) => {
            //             if (
            //                 travellerDetailsUpdate.hasOwnProperty(key) &&
            //                 travellerDetailsOld[key] !== travellerDetailsUpdate[key]
            //             ) {
            //                 acc.push({
            //                     details: key,
            //                     old: travellerDetailsOld[key],
            //                     new: travellerDetailsUpdate[key]
            //                 });
            //             }
            //             return acc;
            //         }, []);
            //         changesValues = changesValues.concat(changedFields); // <-- fix here
            //         // setProposerChangedFields(changedFields);
            //     }
            //     if (nomineesDetailsOld && nomineeDetailsUpdate) {
            //         const changedFields = Object.keys(nomineesDetailsOld).reduce((acc, key) => {
            //             if (
            //                 nomineeDetailsUpdate.hasOwnProperty(key) &&
            //                 nomineesDetailsOld[key] !== nomineeDetailsUpdate[key]
            //             ) {
            //                 acc.push({
            //                     details: key,
            //                     old: nomineesDetailsOld[key],
            //                     new: nomineeDetailsUpdate[key]
            //                 });
            //             }
            //             return acc;
            //         }, []);
            //         changesValues = changesValues.concat(changedFields); // <-- fix here
            //         // setProposerChangedFields(changedFields);
            //     }
            //      const countryOld = payloadData?.change_values?.country_map_docs;
            // const countryUpdated = payloadData?.change_values?.selectedCountries;
            // if (countryOld && countryUpdated) {
            //     const oldCountryNames = countryOld
            //         .map(item => item?.Country?.name)
            //         .filter(Boolean)
            //         .join(', ');

            //     // New: countryUpdated is an array of objects, each has label: "..."
            //     const newCountryNames = countryUpdated
            //         .map(item => item?.label)
            //         .filter(Boolean)
            //         .join(', ');

            //     // Add to changesValues array
            //     changesValues.push({
            //         details: 'country',
            //         old: oldCountryNames,
            //         new: newCountryNames
            //     });
            // }
            //     console.log(changesValues, 'changesValues')
            //     setChangeValues(changesValues || []);
            // }
           setChangeValues(payloadData?.change_values || []);
            setNewDetails(newData || {});
            setPolicyData(policyExtraData || []);
            // const changeValuesForModel = getChangeValuesForTitle(payloadData, "Model");
            // setValuesForModel(changeValuesForModel || []);
            // const changeValuesForVariant = getChangeValuesForTitle(payloadData, "Variant");
            // setValuesForVariant(changeValuesForVariant || []);

            // const changeValuesForFuel = getChangeValuesForTitle(payloadData, "Fuel");
            // setValuesForFuel(changeValuesForFuel || []);
            // const changeValuesForTransmission = getChangeValuesForTitle(payloadData, "Transmission");
            // setValuesForTransmission(changeValuesForTransmission || []);

        }
    }, [rowData]);

    // const viewEditModal = () => {
    //     toggleViewEditModal();
    // };

    const getChangeValuesForTitle = (data, title) => {
        const changeValuesForTitle = data.change_values?.filter(item => item.title === title);
        return changeValuesForTitle;
    };

    const [viewPolicyDetailspModal, setPolicyDetailsModal] = useState(false);
    const togglePolicyDetailsModal = () => setPolicyDetailsModal(!viewPolicyDetailspModal);

    const viewPolicyDetailsModal = () => {
        togglePolicyDetailsModal();
    };

    const handlePreviewFileClick = (docUrl) => {
        window.open(docUrl, "_blank");
    };

    return (

        <Fragment>
            <Row>
                {/* <Modal isOpen={props.isOpen} toggle={props.toggle} size="lg" className="border-0" backdrop="static">

                    <ModalHeader toggle={props.toggle} className=" pb-0 mb-0 border-0">{"Policy Edit Request"} </ModalHeader> */}
                <ModalBody>
                    <TicketModal data={props.rowData} />
                    <Row>
                        <Col sm="12">
                            <Table className="custom-table table-sm">
                                <thead>
                                    <tr>
                                        <th colSpan={3}>Document Details</th>
                                    </tr>
                                </thead>
                                <tbody className="mtd-bg">
                                    {/* {newDetails[0]?.Body?.name && ( */}
                                    <tr>
                                        <th>Document Unique Code</th>
                                        <td>{policyData[0]}</td>
                                        {/* <td>{'-'}</td> */}
                                    </tr><tr>
                                        <th>Traveller Name</th>
                                        <td>{policyData[1]}</td>
                                    </tr>
                                    <tr>
                                        <th>Certificate No</th>
                                        {/* <td>{policyData[2]}</td> */}
                                        {!props.isHistoryTabTrigger ? <td style={{ textDecoration: 'underline', color: 'blue' }}><a href="#modal" onClick={viewPolicyDetailsModal}>{policyData[3]}</a></td> : <td >{policyData[3]}</td>}

                                    </tr>
                                    <tr>
                                        <th>Plan Name</th>
                                        <td>{policyData[2]}</td>
                                    </tr>
                                     <tr>
                                        <th>Document</th>
                                         {documentUrl ? <td  style={{ textDecoration: 'underline', color: 'blue' }}><a href={documentUrl} target='_blank'>View</a></td> : <td >-</td>}
                                    </tr>

                                    {/* )} */}

                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12">
                            {/* Ticekt details */}

                            {/* Ticekt Payload details */}

                            {/* Ticekt history */}
                            <Table className="custom-table table-sm">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Old</th>
                                        <th>New</th>
                                    </tr>
                                </thead>
                                <tbody className="mtd-bg">
                                    {changeValues.length > 0 && (changeValues.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.title ? item.title : '-'}</td>
                                            <td>{item.old ? item.old : '-'}</td>
                                            <td>{item.new ? item.new : '-'}</td>
                                        </tr>
                                    )))}

                                    {/* {newDetails[1]?.Body?.registration_no && (
                                            <tr>
                                                <th>Registration Number</th>
                                                <td>{oldDetails[1]?.Body?.registration_no ? oldDetails[1]?.Body?.registration_no : '-'}</td>
                                                <td>{newDetails[1]?.Body?.registration_no ? newDetails[1]?.Body?.registration_no : '-'}</td>
                                            </tr>
                                        )}
                                        {newDetails[0]?.Body?.name && (
                                            <tr>
                                                <th>Name</th>
                                                <td>{oldDetails[0]?.Body?.name ? oldDetails[0]?.Body?.name : '-'}</td>
                                                <td>{newDetails[0]?.Body?.name ? newDetails[0]?.Body?.name : '-'}</td>
                                            </tr>
                                        )}
                                        {newDetails[0]?.Body?.phone_no && (
                                            <tr>
                                                <th>Mobile Number</th>
                                                <td>{oldDetails[0]?.Body?.phone_no ? oldDetails[0]?.Body?.phone_no : '-'}</td>
                                            <td>{newDetails[0]?.Body?.phone_no ? newDetails[0]?.Body?.phone_no : '-'}</td>
                                            </tr>
                                        )}
                                        {newDetails[0]?.Body?.email && (
                                            <tr>
                                                <th>Email Id</th>
                                                <td>{oldDetails[0]?.Body?.email ? oldDetails[0]?.Body?.email : '-'}</td>
                                                <td>{newDetails[0]?.Body?.email ? newDetails[0]?.Body?.email : '-'}</td>
                                            </tr>
                                        )}
                                        {newDetails[0]?.Body?.Address && (
                                            <tr>
                                                <th>Address</th>
                                                <td>{oldDetails[0]?.Body?.Address ? oldDetails[0]?.Body?.Address : '-'}</td>
                                                <td>{newDetails[0]?.Body?.Address ? newDetails[0]?.Body?.Address : '-'}</td>
                                            </tr>
                                        )}
                                        {newDetails[0]?.Body?.pin_code && (
                                            <tr>
                                                <th>Pincode</th>
                                                <td>{oldDetails[0]?.Body?.pin_code ? oldDetails[0]?.Body?.pin_code : '-'}</td>
                                                <td>{newDetails[0]?.Body?.pin_code ? newDetails[0]?.Body?.pin_code : '-'}</td>
                                            </tr>
                                        )}
                                        {newDetails[0]?.Body?.state && (
                                            <tr>
                                                <th>State</th>
                                                <td>{oldDetails[0]?.Body?.state ? oldDetails[0]?.Body?.state : '-'}</td>
                                                <td>{newDetails[0]?.Body?.state ? newDetails[0]?.Body?.state : '-'}</td>
                                            </tr>
                                        )}
                                        {newDetails[0]?.Body?.city && (
                                            <tr>
                                                <th>City</th>
                                                <td>{oldDetails[0]?.Body?.city ? oldDetails[0]?.Body?.city : '-'}</td>
                                                <td>{newDetails[0]?.Body?.city ? newDetails[0]?.Body?.city : '-'}</td>
                                            </tr>
                                        )}
                                        {valuesForModel?.some(item => item.title === 'Model' && item.new && Object.keys(item.new).length > 0) && (<tr>
                                            <th>Model</th>
                                            <td>{valuesForModel[0]?.old ? valuesForModel[0]?.old : '-'}</td>
                                            <td>{valuesForModel[0]?.new ? valuesForModel[0]?.new : '-'}</td>
                                        </tr>
                                        )}
                                        {valuesForVariant?.some(item => item.title === 'Variant' && item.new && Object.keys(item.new).length > 0) && (
                                            <tr>
                                                <th>Variant</th>
                                                <td>{valuesForVariant[0]?.old ? valuesForVariant[0]?.old : '-'}</td>
                                                <td>{valuesForVariant[0]?.new ? valuesForVariant[0]?.new : '-'}</td>
                                            </tr>
                                        )}
                                        {valuesForFuel?.some(item => item.title === 'Fuel' && item.new && Object.keys(item.new).length > 0) && (
                                            <tr>
                                                <th>Fuel</th>
                                                <td>{valuesForFuel[0]?.old ? valuesForFuel[0]?.old : '-'}</td>
                                                <td>{valuesForFuel[0]?.new ? valuesForFuel[0]?.new : '-'}</td>
                                            </tr>
                                        )}
                                        {valuesForTransmission?.some(item => item.title === 'Transmission' && item.new && Object.keys(item.new).length > 0) && (
                                            <tr>
                                                <th>Transmission</th>
                                                <td>{valuesForTransmission[0]?.old ? valuesForTransmission[0]?.old : '-'}</td>
                                                <td>{valuesForTransmission[0]?.new ? valuesForTransmission[0]?.new : '-'}</td>
                                            </tr>
                                        )} */}
                                    {/* <tr>
                                            <td>Dealership Name</td>
                                            <td>--</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td>Product Name</td>
                                            <td>--</td>
                                            <td>-</td>
                                        </tr> */}
                                    {/* <tr>
                                            <td>KYC</td>
                                            <td>
                                                <Button color="success" 
                                                // onClick={viewKycModal} 
                                                style={{padding: '2px 10px'}}>View</Button>
                                            </td>
                                        </tr> */}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter className="border-0 d-flex justify-content-center">
                    {/* <div className="d-flex justify-content-flex-start">
                            <Button color="success" onClick={viewEditModal}>View</Button>
                        </div> */}
                    {/* <div className="d-flex justify-content-center">
                            <Button color="info" onClick={props.toggle}>Close</Button>
                        </div> */}
                </ModalFooter>
                {/* </Modal> */}
            </Row>


            {/* {viewDealershiEditModal && (<EditPolicyProductChangeModal
                isOpen={viewDealershiEditModal}
                toggle={toggleViewEditModal}
                id={props.id}
            />
            )} */}
            {viewPolicyDetailspModal && <ViewPolicyModal
                isOpen={viewPolicyDetailspModal}
                toggle={togglePolicyDetailsModal}
                salesPolicyId={salesPolicyId}
            />}
        </Fragment>
    );

}

export default PolicyEditRequestModalStep;
